import { systemConfig, loadSystemConfig } from './systemConfig'
import { apiRandomKey, apiMobileCode } from './requestapis'
import encryption from './encryption'
import { notifySupport } from './contactSupport'
export default {
  inject: ['openSupport'],
  data: () => ({ submitting: false }),
  computed: {
    authConfig() { return systemConfig.data },
    smsRequired() { return Number((this.authConfig.sms || {}).register_switch) === 1 },
    inviteRequired() { return Number((this.authConfig.site || {}).invite_code_switch) === 1 }
  },
  methods: {
    async prepareLogin(mobile) {
      const config = await loadSystemConfig(true)
      return Number(config.app.login_calculation_switch) === 1 ? this.$refs.auth.verify('calculation', mobile) : ''
    },
    async sendVerifiedCode(mobile, type) {
      const config = await loadSystemConfig(true), app = config.app || {}
      if (Number((config.sms || {}).sms_status) === 0) { notifySupport(this, '短信服务暂未开放，请联系客服'); return 0 }
      let key = '', answer = ''
      if (Number(app.slide_verify_switch) === 1) {
        const result = await apiRandomKey({ mobile }); if (!result || !result.key) return 0
        key = result.key
        answer = await this.$refs.auth.verify('slider', mobile)
      } else if (Number(app.calculation_code_switch) === 1) answer = await this.$refs.auth.verify('calculation', mobile)
      if (answer === null || this.disposed || (this.ruleForm && this.ruleForm.mobile !== mobile)) return 0
      let signature = mobile + (app.app_num_key || '') + key
      for (let i = 0; i < 3; i++) signature = encryption.hex_encryption(signature)
      return apiMobileCode({ mobile, type, encrypt_string: signature, captcha_code: answer })
    }
  }
}
